/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */

import { createPMMarkSpecFactory } from '../../schema/createPMSpecFactory';
export var alignment = createPMMarkSpecFactory({
  attrs: {
    align: {}
  },
  excludes: 'alignment indentation',
  group: 'alignment'
});
export var annotation = createPMMarkSpecFactory({
  attrs: {
    id: {
      default: ''
    },
    annotationType: {
      default: 'inlineComment'
    }
  },
  inclusive: true,
  excludes: '',
  group: 'annotation'
});
export var backgroundColor = createPMMarkSpecFactory({
  attrs: {
    color: {}
  },
  inclusive: true,
  excludes: 'color',
  group: 'color'
});
export var border = createPMMarkSpecFactory({
  attrs: {
    size: {},
    color: {}
  },
  inclusive: false
});
export var breakout = createPMMarkSpecFactory({
  attrs: {
    mode: {
      default: 'wide'
    },
    width: {
      default: null
    }
  },
  inclusive: false,
  spanning: false
});
export var code = createPMMarkSpecFactory({
  inclusive: true,
  excludes: 'fontStyle link searchQuery color'
});
export var confluenceInlineComment = createPMMarkSpecFactory({
  attrs: {
    reference: {
      default: ''
    }
  },
  inclusive: false,
  excludes: ''
});
export var dataConsumer = createPMMarkSpecFactory({
  attrs: {
    sources: {
      default: []
    }
  }
});
export var em = createPMMarkSpecFactory({
  inclusive: true,
  group: 'fontStyle'
});
export var fragment = createPMMarkSpecFactory({
  attrs: {
    localId: {
      default: ''
    },
    name: {
      default: null
    }
  },
  inclusive: false,
  excludes: ''
});
export var indentation = createPMMarkSpecFactory({
  attrs: {
    level: {}
  },
  excludes: 'indentation alignment',
  group: 'indentation'
});
export var link = createPMMarkSpecFactory({
  attrs: {
    href: {},
    __confluenceMetadata: {
      default: null
    }
  },
  inclusive: false,
  excludes: 'link',
  group: 'link'
});
export var strike = createPMMarkSpecFactory({
  inclusive: true,
  group: 'fontStyle'
});
export var strong = createPMMarkSpecFactory({
  inclusive: true,
  group: 'fontStyle'
});
export var subsup = createPMMarkSpecFactory({
  attrs: {
    type: {
      default: 'sub'
    }
  },
  inclusive: true,
  group: 'fontStyle'
});
export var textColor = createPMMarkSpecFactory({
  attrs: {
    color: {}
  },
  inclusive: true,
  group: 'color'
});
export var typeAheadQuery = createPMMarkSpecFactory({
  attrs: {
    trigger: {
      default: ''
    }
  },
  inclusive: true,
  group: 'searchQuery'
});
export var underline = createPMMarkSpecFactory({
  inclusive: true,
  group: 'fontStyle'
});
export var unsupportedMark = createPMMarkSpecFactory({
  attrs: {
    originalValue: {}
  },
  excludes: ''
});
export var unsupportedNodeAttribute = createPMMarkSpecFactory({
  attrs: {
    unsupported: {},
    type: {}
  }
});